import { Effect } from "../../Materials/effect";
var name = 'imageProcessingCompatibility';
var shader = "#ifdef IMAGEPROCESSINGPOSTPROCESS\ngl_FragColor.rgb=pow(gl_FragColor.rgb,vec3(2.2));\n#endif";
Effect.IncludesShadersStore[name] = shader;
/** @hidden */
export var imageProcessingCompatibility = { name: name, shader: shader };
//# sourceMappingURL=imageProcessingCompatibility.js.map